import React, { useRef, useState } from 'react';
import { ChevronDown, ChevronUp, Gift } from 'lucide-react';
import { Reveal } from '../Reveal';
import { bonos } from '../../data/content';
const estilosIcono = ['bg-orange-400/10 ring-orange-400/25', 'bg-blue-400/10 ring-blue-400/25', 'bg-violet-400/10 ring-violet-400/25', 'bg-sky-400/10 ring-sky-400/25', 'bg-dorado/10 ring-dorado/25'];
export function BonosCarousel() {
  const [openIndex, setOpenIndex] = useState(0);
  const touchStartY = useRef<number | null>(null);
  const listRef = useRef<HTMLUListElement>(null);
  const selectBono = (index: number) => {
    const nextIndex = Math.max(0, Math.min(bonos.length - 1, index));
    setOpenIndex(nextIndex);
    window.setTimeout(() => {
      const selected = listRef.current?.querySelector<HTMLElement>(`[data-bono-index="${nextIndex}"]`);
      selected?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }, 40);
  };
  const handleTouchEnd = (event: React.TouchEvent<HTMLUListElement>) => {
    if (touchStartY.current === null) return;
    const distance = event.changedTouches[0].clientY - touchStartY.current;
    touchStartY.current = null;
    if (Math.abs(distance) < 50) return;
    selectBono(openIndex + (distance < 0 ? 1 : -1));
  };
  return <section aria-labelledby="bonos-titulo" className="relative w-full overflow-hidden bg-tinta px-4 py-16 sm:px-6 sm:py-20" data-id="element-59" data-mp="3nlk3ex554p61">
      <div className="pointer-events-none absolute -left-24 top-10 h-64 w-64 rounded-full bg-bordo/40 blur-3xl" aria-hidden="true" data-id="element-60" data-mp="k1xnrwoclz02" />
      <div className="pointer-events-none absolute -right-24 bottom-0 h-64 w-64 rounded-full bg-verde/10 blur-3xl" aria-hidden="true" data-id="element-61" data-mp="p10s1ewi816z" />

      <div className="relative mx-auto max-w-5xl" data-id="element-62" data-mp="aatg7i105gf9">
        <Reveal data-id="element-63" data-mp="fafwy1g1hest">
          <div className="text-center" data-id="element-64" data-mp="f9xrce7hlo88">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-dorado/10 text-dorado ring-1 ring-dorado/40" data-id="element-65" data-mp="131lcefi2i52l">
              <Gift className="h-7 w-7" aria-hidden="true" data-id="element-66" data-mp="17stkn87nvke6" />
            </span>
            <h2 id="bonos-titulo" className="mt-7 bg-gradient-to-r from-dorado via-white to-dorado bg-clip-text font-display text-3xl font-bold text-transparent sm:text-5xl" data-id="element-67" data-mp="1hoa9ybsre86c">
              Más los 5 Bonos Estratégicos
            </h2>
            <p className="mt-3 text-base text-white/70 sm:text-lg" data-id="element-68" data-mp="18liv020ocu9y">Incluidos con tu compra — sin costo extra</p>
          </div>
        </Reveal>

        <div className="mt-10 flex items-center gap-3 sm:mt-12" data-id="element-69" data-mp="yowd9m3najc5">
          <ul ref={listRef} className="min-w-0 flex-1 space-y-4" onTouchStart={event => {
          touchStartY.current = event.touches[0].clientY;
        }} onTouchEnd={handleTouchEnd} data-id="element-70" data-mp="yr93snngy20t">
            {bonos.map((bono, index) => {
            const open = openIndex === index;
            const triggerId = `bono-trigger-${index}`;
            const panelId = `bono-panel-${index}`;
            return <Reveal key={bono.numero} as="li" delay={Math.min(index, 3) * 0.04} data-id="element-71" data-mp="b0mvcv9jyfqa" data-mpi={index}>
                  <article data-bono-index={index} className="overflow-hidden rounded-2xl border border-white/15 bg-white/[0.07] shadow-[0_8px_24px_rgba(0,0,0,0.16)] transition-[background-color,border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-dorado/30 hover:bg-white/[0.1]" data-id="element-72" data-mp="2mnqc21igf0fg">
                    <h3 data-id="element-73" data-mp="30mzu76q804m2">
                      <button id={triggerId} type="button" onClick={() => selectBono(index)} aria-expanded={open} aria-controls={panelId} className="flex min-h-[104px] w-full items-center gap-4 px-4 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-3px] focus-visible:outline-dorado sm:gap-6 sm:px-7" data-id="element-74" data-mp="30m6hlp4kykw0">
                        <span className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-full text-2xl ring-1 ${estilosIcono[index]}`} aria-hidden="true" data-id="element-75" data-mp="1l5pm66qa3kzz">
                          {bono.icono}
                        </span>

                        <span className="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between sm:gap-6" data-id="element-76" data-mp="1143h6anqwmyl">
                          <span className="block font-display text-lg font-bold leading-snug text-white sm:text-2xl" data-id="element-77" data-mp="1ft9etu6xq54d">
                            {bono.numero} — {bono.titulo}
                          </span>
                          <span className="mt-3 inline-flex shrink-0 rounded-md border border-verde/40 bg-verde/15 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-wide text-verde sm:mt-0 sm:text-xs" data-id="element-78" data-mp="1osmn4jjbonni">
                            {bono.etiqueta}
                          </span>
                        </span>

                        <ChevronDown className={`h-5 w-5 shrink-0 text-white/50 transition-transform duration-300 ${open ? 'rotate-180 text-dorado' : ''}`} aria-hidden="true" data-id="element-79" data-mp="1tttu4gdn5it4" />
                      </button>
                    </h3>

                    <div id={panelId} role="region" aria-labelledby={triggerId} className={`grid transition-[grid-template-rows,opacity] duration-300 ease-out ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-80" data-mp="3vlyglccdfnwg">
                      <div className="overflow-hidden" data-id="element-81" data-mp="21cjlyu0esv4o">
                        <p className="border-t border-white/10 bg-black/10 px-5 py-5 text-sm font-medium leading-relaxed text-white/85 sm:px-[7.25rem] sm:py-6 sm:text-base" data-id="element-82" data-mp="219xfyyt62nok">
                          {bono.descripcionCompleta}
                        </p>
                      </div>
                    </div>
                  </article>
                </Reveal>;
          })}
          </ul>

          <div className="hidden shrink-0 flex-col gap-2 sm:flex" aria-label="Navegación de bonos" data-id="element-83" data-mp="1ifa3bf2wrloh">
            <button type="button" onClick={() => selectBono(openIndex - 1)} disabled={openIndex === 0} aria-label="Bono anterior" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white transition-colors hover:bg-white/20 disabled:cursor-not-allowed disabled:opacity-35" data-id="element-84" data-mp="1necxg4hco7ho">
              <ChevronUp className="h-5 w-5" aria-hidden="true" data-id="element-85" data-mp="3baaz2xs4y3xl" />
            </button>
            <button type="button" onClick={() => selectBono(openIndex + 1)} disabled={openIndex === bonos.length - 1} aria-label="Bono siguiente" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white transition-colors hover:bg-white/20 disabled:cursor-not-allowed disabled:opacity-35" data-id="element-86" data-mp="36ayekjoql8y6">
              <ChevronDown className="h-5 w-5" aria-hidden="true" data-id="element-87" data-mp="3u1u1p3i8zfz3" />
            </button>
          </div>
        </div>

        <Reveal delay={0.05} data-id="element-88" data-mp="3p87vnu6laac9">
          <p className="mt-10 text-center font-display text-xl font-bold text-white sm:text-2xl" data-id="element-89" data-mp="3kapn44whhx4s">
            🎁 GRATIS — Incluidos siempre
          </p>
        </Reveal>
      </div>
    </section>;
}